import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/taggedTemplateLiteralLoose";
function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  border: 0px;\n  clip: rect(0px, 0px, 0px, 0px);\n  height: 1px;\n  width: 1px;\n  margin: -1px;\n  padding: 0px;\n  overflow: hidden;\n  white-space: nowrap;\n  position: absolute;\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
import styled from "@emotion/styled";
import Box from "../Box";
var VisuallyHidden = styled(Box)(_templateObject());
VisuallyHidden.displayName = "VisuallyHidden";
export default VisuallyHidden;